import { VatDisplayMode } from "interfaces/contracts";
import type { Contract } from "interfaces/contracts";

export const DEFAULT_VAT_DISPLAY_MODE = VatDisplayMode.FEE_PLUS_VAT;

const KNOWN_MODES: readonly string[] = Object.values(VatDisplayMode);

export function resolveVatDisplayMode(contract: Pick<Contract, "vatDisplayMode"> | undefined): VatDisplayMode {
	const mode = contract?.vatDisplayMode;
	return mode && KNOWN_MODES.includes(mode) ? mode : DEFAULT_VAT_DISPLAY_MODE;
}

export function hasVatRate(contract: Pick<Contract, "vat"> | undefined): boolean {
	return contract?.vat != null && contract.vat > 0;
}

export function showsFeeVat(contract: Pick<Contract, "vat" | "hoteliseFee"> | undefined): boolean {
	return hasVatRate(contract) && contract?.hoteliseFee != null && contract.hoteliseFee > 0;
}

export function computeFeeBreakdown(netFee: number, vatPercent: number): { gross: number; net: number; vatShare: number } {
	const netCents = Math.round(netFee * 100);
	const vatCents = Math.round(Number(((netCents * vatPercent) / 100).toFixed(8)));
	return { gross: (netCents + vatCents) / 100, net: netCents / 100, vatShare: vatCents / 100 };
}

export function headlineFee(contract: Pick<Contract, "hoteliseFee" | "vat" | "vatDisplayMode"> | undefined): number {
	const fee = contract?.hoteliseFee ?? 0;
	if (showsFeeVat(contract) && resolveVatDisplayMode(contract) === VatDisplayMode.FEE_INCLUDES_VAT) {
		return computeFeeBreakdown(fee, contract?.vat ?? 0).gross;
	}
	return fee;
}
